import { useState, useEffect } from 'react';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isTransparent = transparent && !scrolled && !mobileOpen;

  const navLinks = [
    { href: '/', label: '首页' },
    { href: '/category/films-tv', label: '影视剧集' },
    { href: '/category/news-info', label: '新闻资讯' },
    { href: '/category/entertainment', label: '娱乐综艺' },
    { href: '/category/tech-digital', label: '科技数码' },
    { href: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className={`flex items-center gap-2 font-heading text-xl font-bold whitespace-nowrap ${
              isTransparent ? 'text-white' : 'text-foreground-900'
            }`}
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-white rounded-md text-sm font-bold">
              国
            </span>
            <span>国产传媒</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isTransparent
                    ? 'text-white/80 hover:text-white hover:bg-white/10'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-md border transition-colors whitespace-nowrap ${
                isTransparent
                  ? 'border-white/30 text-white hover:bg-white/10'
                  : 'border-foreground-300 text-foreground-700 hover:border-foreground-500'
              }`}
            >
              联系我们
            </Link>
            <a
              href="/about"
              className="px-4 py-2 text-sm rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              创作者入驻
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
              isTransparent ? 'text-white' : 'text-foreground-700'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="px-3 py-3 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 rounded-md"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/60">
              <Link
                to="/about"
                className="flex-1 px-4 py-2 text-sm text-center border border-foreground-300 text-foreground-700 rounded-md"
                onClick={() => setMobileOpen(false)}
              >
                联系我们
              </Link>
              <a
                href="/about"
                className="flex-1 px-4 py-2 text-sm text-center bg-primary-500 text-white rounded-md whitespace-nowrap"
              >
                创作者入驻
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}